import * as _ from 'lodash';
import { select, Store } from "@ngrx/store";
import { Subject } from "rxjs";
import { filter, takeUntil } from "rxjs/operators";

import { FormService } from "../services/form.service";
import { CampaignFormService } from "../services/campaign-form.service";

import { selectCampaignSelected } from "../features/campaign.selectors";
import { setPresetOptionList } from "../features/option.actions";

import { CAMPAIGN_TOKEN } from '../tokens/campaign.token';
import { CampaignEventHandlerService } from '../services/campaign-event-handler.service';

class Campaign {
    public takeUntilSubject: Subject<any> = new Subject();

    public campaign$ = this.store.pipe(
        select(selectCampaignSelected),
        filter(campaign => _.isObject(campaign)),
        takeUntil(this.takeUntilSubject)
    );

    constructor(
        public store: Store,
        public formService: FormService,
        public campaignFormService: CampaignFormService,
        public campaignEventHandlerService: CampaignEventHandlerService
    ) {
        this.campaign$.subscribe(campaign => {
            this.formService.reset(this.campaignFormService.form);
            this.campaignFormService.initialize(campaign);

            this.store.dispatch({
                type: setPresetOptionList.type,
                data: campaign.campaignTypeData.presetOptions
            });

            this.campaignEventHandlerService.onUpdateCampaign.next(campaign);
        });
    }

    public destroy() {
        this.takeUntilSubject.next(null);
        this.takeUntilSubject.complete();
    }
}

export const campaignFactory = (
    store: Store,
    formService: FormService,
    campaignFormService: CampaignFormService,
    campaignEventHandlerService: CampaignEventHandlerService
) => {
    return new Campaign(store, formService, campaignFormService, campaignEventHandlerService);
}

export const campaignProvider = {
    provide: CAMPAIGN_TOKEN,
    useFactory: campaignFactory,
    deps: [Store, FormService, CampaignFormService, CampaignEventHandlerService]
};
